
/**
 * Lechia Helper
 */

 let LechiaHelper = {

    /**
     * Get the URL Parameter
     * @returns {string}
     */
    getUrlParams() {
        return Object.fromEntries(new URLSearchParams(window.location.search).entries());
    },

    /**
     * Get a specific key from the URL parameters
     * @param {*} key 
     * @returns 
     */
    getUrlParam(key) {
        return this.getUrlParams()[key];
    },

    /**
     * Get the URL Query String
     * @returns {string}
     */
    getQueryString() {
        const params = this.getUrlParams();
        return Object.keys(params).map(key => key + '=' + params[key]).join('&');
    },

    /**
     * Slugify
     * @param {*} text 
     * @returns {string}} 
     */
    slugify(text) {
        return text.toString().toLowerCase()
            .replace(/\s+/g, '_')           // Replace spaces with _
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '_')         // Replace multiple _ with single _
            .replace(/^-+/, '')             // Trim _ from start of text
            .replace(/-+$/, '');            // Trim _ from end of text
    }

 };